import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { httpsCallable } from 'firebase/functions';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db, functions, storage } from '../../../firebase/config';
import { getActiveTenantId } from '../../../firebase/tenant';
import { logger } from '../../../services/logger';

async function uploadScreenshot(screenshotFile, user) {
  if (!screenshotFile || !user) return null;
  try {
    const timestamp = Date.now();
    const cleanName = screenshotFile.name.replace(/[^a-zA-Z0-9.-]/g, '_');
    const storagePath = `feedback-attachments/${user.uid}/${timestamp}_${cleanName}`;
    const storageRef = ref(storage, storagePath);
    await uploadBytes(storageRef, screenshotFile);
    return await getDownloadURL(storageRef);
  } catch (uploadErr) {
    logger.warn('FeedbackModal: Screenshot upload error, continuing without image:', uploadErr);
    return null;
  }
}

export async function submitFeedbackPayload({
  type,
  title,
  description,
  screenshotFile,
  user,
  userDetails,
  metadata,
  envLabel,
}) {
  const screenshotUrl = await uploadScreenshot(screenshotFile, user);

  const payload = {
    type,
    title: title.trim(),
    description: description.trim(),
    userName: userDetails.userName,
    userEmail: userDetails.userEmail,
    userPhone: userDetails.userPhone,
    userRole: userDetails.userRole,
    accountId: userDetails.accountId,
    uid: userDetails.userUid,
    userUid: userDetails.userUid,
    linkedAccountIds: userDetails.linkedAccountIds,
    currentUrl: metadata.url,
    route: metadata.route,
    userAgent: metadata.userAgent,
    environment: envLabel,
    screenshotUrl,
    tenantId: getActiveTenantId(),
  };

  try {
    const submitFn = httpsCallable(functions, 'submitFeedbackReport');
    const res = await submitFn(payload);
    if (res?.data?.success) {
      return res.data;
    }
  } catch (fnErr) {
    logger.warn('FeedbackModal: submitFeedbackReport callable failed, falling back to Firestore direct write:', fnErr);
  }

  const refNumber = `TAS-${Date.now().toString(36).toUpperCase()}`;
  const docRef = await addDoc(collection(db, 'feedback_reports'), {
    ...payload,
    userId: user ? user.uid : 'anonymous',
    tenantId: getActiveTenantId(),
    status: 'new',
    createdVia: 'firestore_direct',
    refNumber,
    createdAt: serverTimestamp(),
  });

  return {
    success: true,
    reportId: docRef.id,
    issueNumber: null,
    fallbackRef: refNumber,
  };
}
